import moment from 'moment'

const isISODate = str => {
  if (typeof str !== 'string') {
    return false
  }

  return str.match(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?(Z|[+-]\d{2}:?\d{2})/) !== null
}

const guaranteeISOString = str => (new Date(str)).toISOString()


const stringToISODate = (str) => {
  if (!str) {
    return ''
  }

  if (isISODate(str)) {
    return guaranteeISOString(str)
  }

  const split = str.split('/')
  return `${split[2]}-${split[1]}-${split[0]}`
}

const dateToCompare = str => {
  const regex = /^(\d{2})\/(\d{2})\/(\d{4}).*/
  str = str ? str.replace(regex, '$3-$2-$1') : ''
  return str
}

const dayAndMonthToCompare = str => {
  const regex = /^(\d{2})\/(\d{2})\.*/
  str = str ? str.replace(regex, '$2-$1') : ''
  return str
}

const getDateFromISO = date => {
  return date.split('T')[0]
}

const diffInDays = (firstDate, secondDate) =>
  (new Date(firstDate) - new Date(secondDate)) / (1000 * 60 * 60 * 24)

const beginOfDay = date => stringToISODate(date)

const endOfDay = date => {
  const dateStr = stringToISODate(date)
  return dateStr.replace('T00:00:00.000Z', 'T23:59:59.999Z')
}

const turnDatetime = time => {
  time = time.split(':')

  const date = new Date()
  date.setHours(time[0], time[1], 0)

  return date
}

const horaAMaiorHoraB = (strHoraA, strHoraB) => {
  if (strHoraA.length === 2) {
    strHoraA += ':00'
  }
  if (strHoraB.length === 2) {
    strHoraB += ':00'
  }
  if ((strHoraA.length === 5) && (strHoraB.length === 5)) {
    let dataHoraObjA = turnDatetime(strHoraA)
    let dataHoraObjB = turnDatetime(strHoraB)
    return dataHoraObjA > dataHoraObjB
  }
  return false
}

const localeStringToISODate = (dateString) => moment(dateString, 'DD/MM/YYYY').toISOString()

export {
  isISODate,
  stringToISODate,
  getDateFromISO,
  dateToCompare,
  dayAndMonthToCompare,
  diffInDays,
  beginOfDay,
  endOfDay,
  turnDatetime,
  horaAMaiorHoraB,
  localeStringToISODate
}
